var _style, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 629 200",
    style: {
      enableBackground: "new 0 0 629 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 33.2,
    cy: 33.2,
    rx: 29.9,
    ry: 29.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 156.5,
    cy: 33.2,
    rx: 29.9,
    ry: 29.9
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 33.2,
    cy: 156.1,
    rx: 29.9,
    ry: 29.9
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 156.5,
    cy: 156.1,
    rx: 29.9,
    ry: 29.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.7,0C80.4,0.4,69.3,2.8,58.8,7.1c14.3,14.3,14.3,37.5,0,51.8s-37.5,14.3-51.8,0c0,0,0,0,0,0 C2.8,69.3,0.4,80.4,0,91.7h52.2c1.6-21.1,18.4-37.8,39.4-39.5V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.9,58.6c-13.8,14.8-36.9,15.7-51.7,1.9c-14.8-13.8-15.7-36.9-1.9-51.7c0.6-0.6,1.1-1.2,1.7-1.7 c-10.4-4.2-21.4-6.6-32.6-7v52.3c21.1,1.6,37.8,18.4,39.4,39.5h52.2C189.7,80.3,187.2,69.1,182.9,58.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.8,98.4c-1.6,21.1-18.4,37.8-39.4,39.5v52.3c11.4-0.4,22.6-2.8,33.2-7.2c-14.4-14.2-14.5-37.4-0.2-51.8 c14.2-14.4,37.4-14.5,51.8-0.2c4.2-10.4,6.6-21.4,7-32.6L137.8,98.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,182.8c10.6,4.5,22,6.9,33.5,7.3v-52.3c-21.1-1.6-37.8-18.4-39.4-39.5H0c0.4,11.1,2.7,22,6.8,32.3 c14-14.6,37.2-15,51.8-1s15,37.2,1,51.8C59.2,181.9,58.7,182.4,58.2,182.8L58.2,182.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235,30.1h-30.6V8.5h87.3v21.6h-31v92.1H235V30.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.1,74.1h-41.8v27H378v21.1h-72.6V8.5h70.1v21.1h-44.4v23.6h41.8V74.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422,93l-8.1,29.2h-26.7L422,8.5h33.7L491,122.2h-27.7L454.5,93H422z M450.8,73.8l-7.1-24.1 c-2-6.8-4-15.2-5.7-21.9h-0.3c-1.7,6.8-3.4,15.3-5.2,21.9l-6.7,24.1L450.8,73.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M602.2,78.7c-0.5-13.7-1-30.2-1-46.7h-0.5c-3.5,14.5-8.3,30.7-12.6,44l-13.8,44.4h-20.1l-12.1-44 c-3.7-13.3-7.6-29.5-10.3-44.3h-0.3c-0.7,15.3-1.2,32.9-2,47.1l-2,43.2h-23.8l7.2-113.7H545l11.1,38c3.5,13.1,7.1,27.3,9.6,40.6h0.5 c3.2-13.2,7.1-28.2,10.8-40.9l12.1-37.8h33.5l6.2,113.7h-25.1L602.2,78.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.3,183.8c-3.9,1.8-8.1,2.7-12.4,2.6c-9.5,0-14.4-5.4-14.4-14c0-10.2,7.4-20.7,19.4-20.7 c6.8,0,11.6,3.8,11.6,10c0,8.5-8.2,11.6-21.6,11.3c0,1.2,0.4,2.4,1,3.4c1.3,1.7,3.6,2.6,6.4,2.6c3.2,0,6.4-0.7,9.3-2.1L255.3,183.8z  M246.6,158.8c-4.6,0-7.2,3.8-7.8,6.9c7.6,0.1,11.5-1,11.5-4C250.2,160,248.9,158.8,246.6,158.8L246.6,158.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.6,185.7l9.3-48.4h9.8l-9.3,48.4H260.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296.6,143l-1.8,9.4h7.1l-1.4,7.4h-7.1l-2.2,11.3c-0.3,1.4-0.5,2.8-0.5,4.2c0,1.6,0.7,2.8,2.8,2.8 c0.9,0,1.8,0,2.7-0.1l-1.1,7.7c-1.9,0.5-3.8,0.8-5.8,0.8c-5.9,0-8.7-3-8.7-7.2c0-2.1,0.3-4.2,0.7-6.2l2.6-13.3h-4.2l1.4-7.4h4.3 l1.4-7L296.6,143z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.2,199.2l6.4-34c0.8-4,1.6-9.5,2-12.9h8.8l-0.6,4.8h0.1c2.5-3.4,6.5-5.5,10.7-5.6c7.2,0,10.7,5.8,10.7,12.6 c0,11.6-7.7,22.2-19.3,22.2c-2.1,0.1-4.3-0.4-6.2-1.4h-0.1l-2.7,14.1L322.2,199.2z M336.2,177.4c1.2,1.1,2.8,1.7,4.5,1.6 c5.2,0,9.3-7.5,9.3-14.1c0-2.7-1.1-5.5-4.3-5.5c-3.7,0-7.1,4.2-8.3,10.7L336.2,177.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.4,152.4l-4.3,22.5c-0.8,4.2-1.3,7.9-1.8,10.9h-8.7l0.6-5.5h-0.1c-3.4,4.4-7.5,6.2-11.5,6.2 c-5.3,0-8.5-3-8.5-9.4c0-2.1,0.2-4.1,0.7-6.1l3.5-18.6h9.8l-3.3,17.9c-0.3,1.4-0.4,2.9-0.5,4.4c0,2.2,0.8,3.9,3.3,3.9 c3.3,0,6.8-4,8-10.7l2.9-15.4L398.4,152.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.4,137.3l-4,19h0.1c2.6-3,6.3-4.7,10.3-4.7c7,0,10.1,5.7,10.1,11.6c0,10.8-7.1,23.3-22.1,23.3 c-7.9,0-11.9-3.4-11.9-9.4c0-2,0.3-4.1,0.8-6.1l6.8-33.8L418.4,137.3z M411.5,171.7c-0.2,1.2-0.3,2.4-0.3,3.7 c-0.1,1.9,1.3,3.6,3.2,3.7c0.2,0,0.4,0,0.5,0c5.7,0,9.8-7.9,9.8-13.8c0-3.2-1.4-5.7-4.4-5.7c-3.5,0-7,3.6-8.2,9.4L411.5,171.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M436.6,185.7l9.3-48.4h9.8l-9.3,48.4H436.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.8,185.7l6.3-33.4h9.8l-6.3,33.4H453.8z M461.5,143.4c0-3.1,2.5-5.6,5.6-5.6c0,0,0,0,0.1,0 c2.6-0.2,4.8,1.8,4.9,4.4c0,0.2,0,0.3,0,0.5c0,3.5-2.7,5.5-5.8,5.5c-2.5,0.1-4.6-1.8-4.8-4.3C461.5,143.8,461.5,143.6,461.5,143.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.1,176.9c2.7,1.4,5.7,2.2,8.7,2.3c2.8,0,4.2-1.4,4.2-3s-1.1-2.8-4.2-4.3c-3.9-1.9-7.1-4.7-7.1-8.9 c0-6.9,6.1-11.5,14.7-11.5c3.9,0,7,0.8,8.6,1.7l-2.3,7c-2.1-1-4.4-1.5-6.7-1.5c-2.6,0-4.4,1.2-4.4,2.9c0,1.4,1.4,2.5,4.1,3.8 c3.6,1.8,7.4,4.5,7.4,9.1c0,7.6-6.5,11.7-15.3,11.7c-4.2,0-8.2-1.1-10.2-2.6L472.1,176.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.3,185.7l9.1-48.4h9.8l-3.7,19.3l0.1,0.1c2.6-3.2,6.5-5,10.6-5.1c5.2,0,8.4,3.3,8.4,9c-0.1,2-0.3,4-0.6,6 l-3.6,19.1h-9.8l3.4-18.3c0.3-1.4,0.5-2.8,0.5-4.2c0-2.2-1-3.8-3.4-3.8c-3.4,0-6.9,4.2-8.2,10.9l-2.9,15.3L498.3,185.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M535.7,185.7l6.3-33.4h9.8l-6.3,33.4H535.7z M543.4,143.4c0-3.1,2.5-5.6,5.5-5.6c0,0,0.1,0,0.1,0 c2.6-0.2,4.7,1.8,4.9,4.3c0,0.2,0,0.3,0,0.5c0,3.5-2.7,5.5-5.8,5.5c-2.5,0.1-4.6-1.8-4.8-4.3C543.4,143.8,543.4,143.6,543.4,143.4 L543.4,143.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M552.8,185.7l4.2-22.5c0.8-4.2,1.4-7.9,1.8-10.9h8.7l-0.7,5.5h0.2c2.6-3.9,7-6.3,11.7-6.3 c5.5,0,8.5,3.3,8.5,9.1c-0.1,1.9-0.2,3.8-0.5,5.7l-3.7,19.4h-9.8l3.5-18.5c0.2-1.2,0.3-2.5,0.3-3.8c0-2.3-0.8-4-3.3-4 c-3.2,0-7,4-8.3,11.4l-2.8,14.8L552.8,185.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.4,190.4c1.8,1.1,5.9,1.8,8.7,1.8c4.9,0,8.6-2.2,10-8.9l0.5-2.8h-0.1c-2.6,3.3-5.6,4.9-9.5,4.9 c-6.6,0-10.6-5.4-10.7-11.9c0-11.1,7.8-22,22.4-22c4.2,0,8.4,0.8,12.3,2.4l-5,27.5c-1.2,6.1-3,11.6-7,14.8 c-3.6,2.9-8.5,3.8-12.9,3.8s-8.6-0.8-10.8-2.1L592.4,190.4z M615.3,159.8c-1.1-0.4-2.3-0.6-3.5-0.6c-5.9,0-10.2,6.6-10.2,13 c0,3.3,1.5,5.8,4.5,5.8c3.2,0,6.5-3.5,7.5-9.2L615.3,159.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamLogo);
export default __webpack_public_path__ + "static/media/team_logo.56bc4f9ee683a51c8dc7e7a7b5c45d65.svg";
export { ForwardRef as ReactComponent };